<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
            <Col span="24">
                <FormItem label="任务名称" prop="taskName" :class="{requireStar:true}" >
                  <Input v-model="formValidate.taskName"  ></Input>
                </FormItem>
            </Col>
        </Row>
       
         <Row>
            <Col span="24">
                <FormItem label="任务描述" prop="taskInfo" :class="{requireStar:true}" >
                  <Input v-model="formValidate.taskInfo"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="任务来源" prop="taskSource" :class="{requireStar:true}" >
                  <Input v-model="formValidate.taskSource"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="任务目标" prop="taskTarget" :class="{requireStar:true}" >
                  <Input v-model="formValidate.taskTarget"  ></Input>
                </FormItem>
            </Col>
        </Row>
        
      
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      
      
      return {
        userForm: false,
        title:'',
        formValidate: {
          keyword: '',
          supplierInfo: '',
          huntingZone: [],
          checkAllGroup:[],
					checkAllTicketGroup:[],
					checkAllCultureGroup:[],
					checkAllSentimmentGroup:[],
          startTime: '',
          endTime: '',
          minPrice: '',
          maxPrice: '',
          inProvince: '',
          sort: {},
          title:'',
          content: '',
          info:'',
          taskName:'',
          taskInfo:'',
          taskSource:'',
          taskTarget:'',

          
        },
        ruleValidate: {
          taskName: [{
            required: true,
            message: '任务名称不能为空',
            trigger: 'change'
          }],
          taskInfo: [{
            required: true,
            message: '任务描述不能为空',
            trigger: 'change'
          }],
          taskSource: [
            {required: true, message: '任务来源不能为空',trigger: 'change'},
           
          ],
           taskTarget: [
             { required: true, message: '任务目标不能为空', trigger: 'blur' }
          ],
         
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
      
      if(row!=null){
        this.formValidate =row
      }
        
      },
      
    
      
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/tasks' 
            let myData = {
              type:1,
              taskName: this.formValidate.taskName,
              taskInfo: this.formValidate.taskInfo,
              taskSource: this.formValidate.taskSource,
              taskTarget: this.formValidate.taskTarget,
              keyword: this.formValidate.keyword,
              searchData: { huntingZone:
                            {
                             travel:this.formValidate.checkAllGroup,
                             ticket:this.formValidate.checkAllTicketGroup,
                             culture:this.formValidate.checkAllCultureGroup,
                             sentimment:this.formValidate.checkAllSentimmentGroup
                           },
             
                            startTime: this.formValidate.startTime,
                            endTime: this.formValidate.endTime,
                            minPrice: this.formValidate.minPrice,
                            maxPrice: this.formValidate.maxPrice,
                            inProvince: this.formValidate.inProvince,
                            sort:this.formValidate.sort,
                            title:this.formValidate.title,
                            content:this.formValidate.content,
                            info:this.formValidate.info,
                            keyword: this.formValidate.keyword,
                            supplierInfo: this.formValidate.supplierInfo,
                            },
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
              } else {
                 this.$Message.error(response.data.msg);
                 if(response.data.msg=="缺少参数token"){
                    this.$Message.error("登录过期，请重新登录");
                    this.$router.push("/login");
                 }
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/task/taskEdit.vue